export const POKEMONS_INIT = '@pokemons/init';
